import React from "react";
import { ArrowUpRight, Building2 } from "lucide-react";
import { institutions } from "../mock/mock";
import { SectionHeading } from "./SectionHeading";

const marquee = [
  "Growing by Giving",
  "Think Bold",
  "Learn Joyfully",
  "Lead Responsibly",
  "Growing by Giving",
  "Think Bold",
  "Learn Joyfully",
  "Lead Responsibly",
];

export default function Institutions() {
  return (
    <>
      {/* Marquee band */}
      <div className="marquee-wrap overflow-hidden py-6" style={{ background: "var(--teal-800)" }}>
        <div className="marquee-track">
          {[...marquee, ...marquee].map((m, i) => (
            <span key={i} className="flex shrink-0 items-center gap-8 px-8">
              <span
                className="font-display whitespace-nowrap text-[1.35rem]"
                style={{ color: i % 2 ? "var(--gold-200)" : "rgba(251,247,240,.85)" }}
              >
                {m}
              </span>
              <span className="h-[6px] w-[6px] rotate-45" style={{ background: "var(--gold)" }} />
            </span>
          ))}
        </div>
      </div>

      <section id="institutions" className="py-24 lg:py-32" style={{ background: "var(--cream)" }}>
        <div className="mx-auto max-w-[1280px] px-5 lg:px-6">
          <SectionHeading
            eyebrow="The KPR Education Group"
            title="Learning that continues well beyond school"
            sub="A KPR child can move from our classrooms straight into engineering, science, commerce or management within the same trusted campus ecosystem in Coimbatore."
            align="center"
          />

          <div className="mt-16 grid gap-7 lg:grid-cols-2">
            {institutions.map((inst, i) => (
              <a
                key={inst.short}
                href={inst.url}
                target="_blank"
                rel="noreferrer"
                data-reveal=""
                style={{ transitionDelay: `${i * 120}ms`, border: "1px solid rgba(11,59,54,.1)" }}
                className="group relative flex flex-col overflow-hidden rounded-2xl bg-white"
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-8px)";
                  e.currentTarget.style.boxShadow = "0 34px 70px -40px rgba(8,46,41,.5)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "none";
                  e.currentTarget.style.boxShadow = "none";
                }}
              >
                <div className="relative h-[220px] overflow-hidden">
                  <img
                    src={inst.image}
                    alt={inst.name}
                    loading="lazy"
                    className="h-full w-full object-cover group-hover:scale-105"
                    style={{ transition: "transform .8s cubic-bezier(.22,1,.36,1)" }}
                  />
                  <span
                    className="absolute inset-0"
                    style={{ background: "linear-gradient(to top, rgba(5,32,29,.72), rgba(5,32,29,.05))" }}
                  />
                  <span
                    className="absolute bottom-5 left-6 flex items-center gap-2.5 rounded-full px-4 py-2 text-[0.72rem] font-bold tracking-[0.12em] uppercase"
                    style={{ background: "var(--cream)", color: "var(--teal-800)" }}
                  >
                    <Building2 size={13} /> {inst.type}
                  </span>
                </div>

                <div className="flex flex-1 flex-col p-8">
                  <div className="flex items-start justify-between gap-4">
                    <h3 className="font-display text-[1.4rem] leading-snug" style={{ color: "var(--teal-900)" }}>
                      {inst.name}
                    </h3>
                    <span
                      className="grid h-10 w-10 shrink-0 place-items-center rounded-full"
                      style={{ background: "var(--teal-100)", color: "var(--teal-700)", transition: "background .3s ease" }}
                    >
                      <ArrowUpRight
                        size={17}
                        className="group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
                        style={{ transition: "transform .3s ease" }}
                      />
                    </span>
                  </div>
                  <p className="mt-4 text-[0.9rem] leading-relaxed" style={{ color: "var(--muted-ink)" }}>
                    {inst.text}
                  </p>
                  <div className="mt-6 text-[0.78rem] font-semibold tracking-[0.1em] uppercase" style={{ color: "var(--gold)" }}>
                    Visit {inst.short} website
                  </div>
                </div>
              </a>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
